import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, TextInput, TitleBar, View } from '../components/index.js';
import { getMagicItems, getMagicWeaponsAndArmor } from '../logic/Logic.js';

const Play = ({}) => {
  const [infos, setInfos] = useState({});
  const [goldlMin, setGoldMin] = useState(1);
  const [goldMax, setGoldMax] = useState(100000);
  const [options, setOptions] = useState({
    breedingPits: true,
    fireheartConstructMods: false,
    fireHeart: true,
    linchKing: true,
    redKing: true,
    core: true,
    bloodLegacy: true,
    forgottenPact: true,
    wildwoodsMA: false,
    wildwoodsMI: true,
    mazeMalcor: true,
  });

  const [options2, setOptions2] = useState({
    core2: true,
    wildwoodsMA2: true,
  });

  const [randomMi, setrandomMi] = useState({});
  const [randomMWA, setrandomMWA] = useState({});

  useEffect(() => {
    list();
  }, [options, options2, goldlMin, goldMax]);

  const handleOptionChange = (event) => {
    const { name, checked } = event.target;
    setOptions((prevOptions) => ({
      ...prevOptions,
      [name]: checked,
    }));
  };
  const handleOptionChange2 = (event) => {
    const { name, checked } = event.target;
    setOptions2((prevOptions) => ({
      ...prevOptions,
      [name]: checked,
    }));
  };

  const getMI = async () => {
    const items = getMagicItems({ ...options });
    const randomIndex = Math.floor(Math.random() * items.length);
    setrandomMi(items[randomIndex]);
  };

  const getMWA = async () => {
    const items = getMagicWeaponsAndArmor({ core: options2.core2, wildwoodsMA: options2.wildwoodsMA2 });
    const randomIndex = Math.floor(Math.random() * items.length);
    setrandomMWA(items[randomIndex]);
  };

  const purchasePrice = (purchasePrice) => {
    try {
      purchasePrice = purchasePrice.toString().replace(/\D/g, '');
      purchasePrice = parseFloat(purchasePrice);
    } catch (e) {
      purchasePrice = 0;
    }
    return purchasePrice;
  };

  const list = async () => {
    const ret = { magicItems: getMagicItems({ ...options }), magicWeaponsAndArmor: getMagicWeaponsAndArmor({ core: options2.core2, wildwoodsMA: options2.wildwoodsMA2 }) };
    ret.magicItems = ret.magicItems.filter((obj) => purchasePrice(obj.purchasePrice) >= goldlMin && purchasePrice(obj.purchasePrice) <= goldMax);
    ret.magicWeaponsAndArmor = ret.magicWeaponsAndArmor.filter((obj) => purchasePrice(obj.purchasePrice) >= goldlMin && purchasePrice(obj.purchasePrice) <= goldMax);

    setInfos(ret);
  };

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={'Play'}>
      <br></br>

      <View style={{ flexDirection: 'row', maxHeight: '80px' }}>
        <Button style={{ maxWidth: '300px' }} onPress={getMWA} text={'Roll For Magic Weapon and Armor'} />
        <label>
          {randomMWA.item} - {randomMWA.effects}
        </label>
      </View>

      <View style={{ flexDirection: 'row', maxHeight: '80px' }}>
        <Button style={{ maxWidth: '300px' }} onPress={getMI} text={'Roll For Magic Items'} />
        <label>
          {randomMi.item} - {randomMi.effects}
        </label>
      </View>
      <br></br>
      <View style={{ flexDirection: 'row', maxHeight: '80px' }}>
        <TextInput title="Min gold" variant="outlined" style={{ maxWidth: '300px' }} value={goldlMin} onChange={setGoldMin} />
        <TextInput title="Max gold" variant="outlined" style={{ maxWidth: '300px' }} value={goldMax} onChange={setGoldMax} />
      </View>
      <br></br>
      <label>
        <input type="checkbox" name="core2" checked={options2.core2} onChange={handleOptionChange2} />
        Core
      </label>
      <label>
        <input type="checkbox" name="wildwoodsMA2" checked={options2.wildwoodsMA2} onChange={handleOptionChange2} />
        Wildwoods Magic Weapons and Armor
      </label>
      <div></div>

      <table style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>dieroll</th>
            <th>Item</th>
            <th>Purchase Price</th>
            <th>Sale Price</th>
            <th>Effects</th>
          </tr>
        </thead>
        <tbody>
          {infos?.magicWeaponsAndArmor?.map((obj) => {
            return (
              <tr>
                <td>{obj['dieroll']}</td>
                <td>{obj.item}</td>
                <td>{obj.purchasePrice}</td>
                <td>{obj.SalePrice}</td>
                <td>{obj.effects}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <br></br>
      <br></br>
      <br></br>
      <div>
        <label>
          <input type="checkbox" name="core" checked={options.core} onChange={handleOptionChange} />
          Core
        </label>
        <label>
          <input type="checkbox" name="breedingPits" checked={options.breedingPits} onChange={handleOptionChange} />
          Breeding Pits
        </label>
        <label>
          <input type="checkbox" name="fireheartConstructMods" checked={options.fireheartConstructMods} onChange={handleOptionChange} />
          Fireheart Construct Mods
        </label>
        <label>
          <input type="checkbox" name="fireHeart" checked={options.fireHeart} onChange={handleOptionChange} />
          Fire Heart
        </label>
        <label>
          <input type="checkbox" name="linchKing" checked={options.linchKing} onChange={handleOptionChange} />
          Linch King
        </label>
        <label>
          <input type="checkbox" name="mazeMalcor" checked={options.mazeMalcor} onChange={handleOptionChange} />
          Maze Malcor
        </label>
        <label>
          <input type="checkbox" name="redKing" checked={options.redKing} onChange={handleOptionChange} />
          Red King
        </label>
        <label>
          <input type="checkbox" name="bloodLegacy" checked={options.bloodLegacy} onChange={handleOptionChange} />
          Blood Legacy
        </label>
        <label>
          <input type="checkbox" name="forgottenPact" checked={options.forgottenPact} onChange={handleOptionChange} />
          Forgotten Pact
        </label>
        <label>
          <input type="checkbox" name="wildwoodsMA" checked={options.wildwoodsMA} onChange={handleOptionChange} />
          Wildwoods Macic Weapons and Armor
        </label>
        <label>
          <input type="checkbox" name="wildwoodsMI" checked={options.wildwoodsMI} onChange={handleOptionChange} />
          Wildwoods Macic Items
        </label>
      </div>
      <br></br>
      {options.fireheartConstructMods && <label style={{ fontWeight: 900 }}>Rules para construc mods, check Fireheart book.</label>}
      <br></br>
      <table style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>dieroll</th>
            <th>Item</th>
            <th>purchasePrice</th>
            <th>SalePrice</th>
            <th>Effects</th>
          </tr>
        </thead>
        <tbody>
          {infos?.magicItems?.map((obj) => {
            return (
              <tr>
                <td>{obj.dieroll}</td>
                <td>{obj.item}</td>
                <td>{obj.purchasePrice}</td>
                <td>{obj.SalePrice}</td>
                <td>{obj.effects}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </TitleBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Play);
